import React from 'react';
import { Table, Input, Divider,Space, Modal, Button, Col, Form, Radio, Row } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import axios from 'axios';
import ENVIRONMENT from '../../../../environments'
import DottedLoader from '../../DottedLoader';
import SuccessModal from '../../SuccessModal/SuccessModal';
import FileConstants from '../../../../FileConstants';
import { EditOutlined, LoadingOutlined } from '@ant-design/icons';

const title = () => 'Here is title';
const showHeader = true;
const footer = () => 'Here is footer';
const scroll = { y: 240 };
const pagination = { position: 'bottom' };

class CustomersTable extends React.Component {
  state = {
    bordered: false,
    loading: false,
    pagination,
    size: 'default',
    tableLayout: 'fixed',
    title: undefined,
    showHeader,
    footer: false,
    scroll: undefined,
    hasData: true,
    dataSource: null,
    loading: true,
    change_payment_type_modal: false,
    selected_payment_type: '',
    selected_customer: '',
    button_loader: false,
    success_payment_change: false,
    filter_user_types: []
  };

  getColumns = () => [
    {
      title: 'Customer Username',
      dataIndex: 'customer_username',
      key: 'customer_username',
      ...this.getColumnSearchProps('customer_username'),
      render: text => <span>{text}</span>,
    },
    {
        title: 'Customer Profile Name',
        dataIndex: 'profile_name',
        key: 'profile_name',
        ...this.getColumnSearchProps('profile_name'),
        render: text => <span>{text}</span>,
    },
    {
        title: 'Email',
        dataIndex: 'email',
        key: 'email',
        render: text => <span>{text}</span>,
    },
    {
        title: 'Company',
        dataIndex: 'company_name',
        key: 'company_name',
        ...this.getColumnSearchProps('company_name'),
        render: text => <span>{text}</span>,
    },
    {
        title: 'Type',
        dataIndex: 'user_type',
        key: 'user_type',
        filters: this.state.filter_user_types,
        onFilter: (value, record) => record.user_type === value,
        render: text => <span>{text}</span>,
    },
    {
      title: 'Subscription Type',
      dataIndex: 'subscription_package',
      key: 'subscription_package',
      render: text => <span>{text}</span>,
  },
  {
    title: 'Actions',
    key: 'action_usage',
    dataIndex: 'action_usage',
    render: (text, record) => (
      <span>
        {record.company_id ?
        <a target="_blank" onClick={() => window.location.href='/admin-customer-usage/' + record.customer_username + "/" + record.company_id}>View System Usage</a>
        :
        <a target="_blank" onClick={() => window.location.href='/admin-customer-usage/' + record.customer_username+ "/" + -1}>View System Usage</a>}
      </span>
    ),
  },
  
  ];

  openPaymentTypeModal = (record) => {
    console.log(record)
    this.setState({
      payment_type: record.payment_type,
      selected_customer: record.customer_username
    }, () => {
      this.setState({
        change_payment_type_modal: true, //form opened after these values are saved
      })
    })
  };

  closePaymentTypeModal = () => {
    this.setState({
      change_payment_type_modal: false
    })
  }

  componentDidMount = () => {
    this.handleDataSource();
  }

  handleDataSource = () => {
    let filter_user_values = [];
    axios.post(ENVIRONMENT.CUSTOMER_GET_BATCH, {
      })
        .then(res => {
          
          console.log(res);
          console.log(res.data);
          var data = [];
          let user_type_value = null;
          for (let i = 1; i <= (res.data).length; i++) {
            console.log(i);
            if (res.data[i - 1]['user_group'] == 'customer') {
              data.push({
                key: i,
                customer_username: res.data[i - 1]['customer_username'],
                profile_name: res.data[i - 1]['profile_name'],
                company_name: res.data[i - 1]['company_name'],
                user_type: res.data[i - 1]['user_type'],
                email: res.data[i - 1]['email'],
                payment_type: res.data[i - 1]['payment_type'],
                subscription_package: res.data[i - 1]['subscription_package']
              });
              user_type_value = res.data[i - 1]['user_type'];
              if(user_type_value != "" && !filter_user_values.includes(user_type_value)){
                filter_user_values.push(user_type_value)
              }
            }

          }
          // sort alpahabatically
          data = data.sort(function(a, b) {
            return a.customer_username.toLowerCase().localeCompare(b.customer_username.toLowerCase());
          });
          this.handleFilteringOptions(filter_user_values);
          this.setState({
            dataSource: data,
            loading: false
          })
        })
    
  }

  handleFilteringOptions = (filter_user_type_values) => {
    let filter_user_type_objects = [];
    filter_user_type_values.forEach( filter_user_type_value => {
      filter_user_type_objects.push({
        text: filter_user_type_value,
        value: filter_user_type_value,
      })
    });

    this.setState({
      filter_user_types: filter_user_type_objects
    });

  }

  // Search in table functionality
  getColumnSearchProps = dataIndex => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={node => {
            this.searchInput = node;
          }}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
          style={{ marginBottom: 8, display: 'block' }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 90 }}
          >
            Search
          </Button>
          <Button onClick={() => this.handleReset(clearFilters)} size="small" style={{ width: 90 }}>
            Reset
          </Button>
        </Space>
      </div>
    ),
    filterIcon: filtered => <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />,
    onFilter: (value, record) =>
      record[dataIndex]
        ? record[dataIndex].toString().toLowerCase().includes(value.toLowerCase())
        : '',
    onFilterDropdownVisibleChange: visible => {
      if (visible) {
        setTimeout(() => this.searchInput.select(), 100);
      }
    }
  });

  handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    this.setState({
      searchText: selectedKeys[0],
      searchedColumn: dataIndex,
    });
  };

  handleReset = clearFilters => {
    clearFilters();
    this.setState({ searchText: '' });
  };


  handleToggle = prop => enable => {
    this.setState({ [prop]: enable });
  };

  handleSizeChange = e => {
    this.setState({ size: e.target.value });
  };


  handleTitleChange = enable => {
    this.setState({ title: enable ? title : undefined });
  };

  handleHeaderChange = enable => {
    this.setState({ showHeader: enable ? showHeader : false });
  };

  handleFooterChange = enable => {
    this.setState({ footer: enable ? footer : undefined });
  };


  handleScollChange = enable => {
    this.setState({ scroll: enable ? scroll : undefined });
  };

  handleDataChange = hasData => {
    this.setState({ hasData });
  };

  handlePaginationChange = e => {
    const { value } = e.target;
    this.setState({
      pagination: value === 'none' ? false : { position: value },
    });
  }; 

  changePaymentType = (e) => {
    console.log(e.target.value)
    this.setState({
      payment_type: e.target.value
    });
  }

  updateCustomerData = (values) => {
    console.log(values)
    this.setState({
      button_loader: true
    })
    let payload ={
      username: this.state.selected_customer,
      payment_type: values.payment_type
    }
    console.log(payload)
    axios.post(ENVIRONMENT.UPDATE_CUSTOMER_DATA,payload)
    .then(res => {
      console.log(res);
      this.setState({
        button_loader: false,
        success_payment_change: true,
        change_payment_type_modal: false
      });
    })
  }

  render() {
    const { state } = this;
    const { dataSource } = state;

    return (
      <div>
        {
          this.state.loading ? <DottedLoader/> :
          dataSource &&
          <Table {...this.state} columns={this.getColumns()} dataSource={dataSource} />
        }
          <Modal
          visible={this.state.change_payment_type_modal}
          className="modal-share"
          width={788}
          closable={false}
          maskClosable={false}
          destroyOnClose={true}
          onCancel={this.closePaymentTypeModal}
          footer={[
            <div className="justify-in-end">
                <Button disabled={this.state.button_loader} className="modal-okay-gray square font-14" onClick={this.closePaymentTypeModal}>
                  Cancel
                </Button>
                <Button disabled={this.state.button_loader} className="modal-okay square font-14" onClick={() => document.getElementById("save-data").click()}>
                    Update&nbsp;{this.state.button_loader ? <LoadingOutlined/> : ''}
                </Button>
            </div>
          ]}>
          <div style={{padding:"16px 6px 0 14px"}}>
              <div className="justify-in-start" style={{marginBottom: 20}}>
                  <h2 className="manrope f-18 black-14">Select Payment Type</h2>
              </div>
              <Form 
              initialValues={{
                payment_type: this.state.payment_type
              }}
              onFinish={this.updateCustomerData}
              layout="vertical">
                  <Row type='flex' gutter={12}>
                      <Col span={24}>
                          <Form.Item label={''} name="payment_type" rules={[{ required: true,  message: 'Please select a payment type.' }]}>
                              <Radio.Group onChange={this.changePaymentType} className="manrope f-14 black-55" >
                                  <Radio value={'subscription'} className="manrope f-14 black-55">Subscription</Radio>
                                  <Radio value={'prepaid'} className="manrope f-14 black-55">Pay per use</Radio>
                              </Radio.Group>
                          </Form.Item>
                      </Col>
                      <Button id="save-data" type="primary" htmlType="submit" style={{"display": "none"}}>
                          Update
                      </Button>
                  </Row>
              </Form>
          </div>
      </Modal>
      <SuccessModal
      visible={this.state.success_payment_change}
      heading={"Payment Type Successfully Changed!"}
      text={"Payment Type has been changed to " + this.state.payment_type + " for " + this.state.selected_customer + "." }
      footer={[
          <div className="justify-in-center">
              <Button style={{margin:"auto"}} className="modal-okay square font-14" htmlType="submit" onClick={() => {
              window.location.reload();
              }}>
                  Okay
              </Button>
          </div>
      ]}

      />
      </div>
    );
  }
}

export default CustomersTable;
